<template>

  <div class="hit-list-group">
    <div class="hit-list-group-item hit-active">
      {{ $tc("message.board", 1) }}
    </div>
    <div class="hit-list-group-item">
      <div class="hit-form-group hit-text-left">
        {{ $tc("message.board", 1) }}: <b><router-link class="hit-html-a" :to="{ name: 'feedback_board', params: {lang: $route.params.lang, board: entry.board.ID} }">{{ entry.board.name }}</router-link></b>
      </div>
      <div class="hit-form-group hit-text-left">
        {{ $tc("message.feedback", 1) }}: <b>#{{ entry.board.ID }}-{{ entry.ID }}</b>
      </div>

      <div class="hit-form-group hit-text-left">
        {{ $tc("message.date", 1) }}: <b>{{ entry.date }}</b>
      </div>

      <span v-if="settings && settings.view == 'full'">

        <div class="hit-form-group hit-text-left">
          {{ $tc("message.username", 1) }}: <b>{{ entry.name }}</b>
        </div>

        <div class="hit-form-group hit-text-left">
          {{ $tc("message.feedback", 1) }}: <hit_stars :stars="entry.average" :append="true" />
        </div>

      </span>
    </div>
  </div>

</template>

<script>
export default{
  props: {entry: Object, settings: Object}
}
</script>
